import { CallbackObject } from 'api/core/get-page-function';
import { plainToClass } from 'class-transformer';
import { GetWorkerVm } from './get-worker.vm';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';

export const getWorker = async (workerId: string, callback: CallbackObject<GetWorkerVm>) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  try {
    const res: AxiosResponse = await instance.get(`/management/workers/${workerId}`, config);
    callback.success(plainToClass(GetWorkerVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
